import { render, staticRenderFns } from "./participant-details-form.vue?vue&type=template&id=3a4dbe6c&scoped=true"
import script from "./participant-details-form.vue?vue&type=script&lang=js"
export * from "./participant-details-form.vue?vue&type=script&lang=js"
import style0 from "./participant-details-form.vue?vue&type=style&index=0&id=3a4dbe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4dbe6c",
  null
  
)

export default component.exports